import React from "react";
 
import { samplingPointsColumns } from "../../../../../BasicSettings/SamplingSites/components/sections/samplingSitesTabs/samplingPoints/sampling-points-columns";
import { IPrimeTableColumn } from "components/prime-data-table/interfaces";

export const samplingPointsDualTableColumns: IPrimeTableColumn[] = [
    ...samplingPointsColumns.filter((column) => column.field != "metadataTemplate.name"),
];
